<vwui-header>
  <h2 a11yPageTitleLevel="1">{{ 'PAGE_PROJECT_TYPES.title' | translate }}</h2>
</vwui-header>

@if (!loadingSpinnerService.isSpinnerVisible()) {
  <div>
    <vwui-table [compactable]="false">
      <div slot="table-title">{{ 'PAGE_PROJECT_TYPES.table.header' | translate }}</div>
      <vwui-table-row>
        <vwui-table-header
          class="project-type-col project-type-col--name">{{ 'PAGE_PROJECT_TYPES.table.column.name' | translate }}
        </vwui-table-header>
        <vwui-table-header
          class="project-type-col project-type-col--description">{{ 'PAGE_PROJECT_TYPES.table.column.description' | translate }}
        </vwui-table-header>
        <vwui-table-header
          class="project-type-col project-type-col--actions">
        </vwui-table-header>
      </vwui-table-row>
      @for (projectType of projectTypes(); track projectType.id) {
        <vwui-table-row>
          <vwui-table-column class="project-type-col project-type-col--name">
            <a class="project-type-link" (click)="openProjectType(projectType)">
              {{ projectType.name }}
            </a>
          </vwui-table-column>
          <vwui-table-column class="project-type-col project-type-col--description">
            {{ projectType.description }}
          </vwui-table-column>
          <vwui-table-column class="project-type-col project-type-col--actions">
            <vwui-btn-icon icon="edit" (click)="openUpdateProjectTypeModal(projectType)"></vwui-btn-icon>
            <vwui-btn-icon icon="vwui-trash" (click)="openDeleteProjectTypeModal(projectType)"></vwui-btn-icon>
          </vwui-table-column>
        </vwui-table-row>
      }
      <vwui-table-row>
        <vwui-table-column class="project-type-col project-type-col--name">
          <vwui-button class="is-secondary" (click)="openCreateProjectTypeModal()">
            {{ 'PAGE_PROJECT_TYPES.create_type' | translate }}
          </vwui-button>
        </vwui-table-column>
        <vwui-table-column class="project-type-col project-type-col--description">
        </vwui-table-column>
        <vwui-table-column class="project-type-col project-type-col--actions">
        </vwui-table-column>
      </vwui-table-row>
    </vwui-table>
  </div>
}
